import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'stellar',
  templateUrl: 'stellar.component.html',
  styleUrls: ['stellar.component.scss'],
})
export class StellarComponent implements OnInit {

  @ViewChild('stellar', { static: false }) stellar: ElementRef;
  @HostListener('window:resize', ['$event'])
  onResize(event) { this.onWindowResize(); }

  @Input() hasHints = false;
  @Input() hasLevelsBg = false;
  @Input() name = '';
  @Input() set skills(vals) {
    this.prepareSkills(vals);
  };
  @Input() disabled = false;
  @Output() skillsChanged = new EventEmitter<any>();

  totalPages = 1;
  activePages = 1;
  loading = true;
  skillsForm = new FormArray([]);
  viewSkills: any = [];
  categoryList: any = [];
  tradeOffs = null;
  showTradeOffTooltip = null;
  scale = 1;
  isMobile = false;
  verticalIntend = '0px auto';
  experienceLevels = [
    { value: 1, label: 'No experience' },
    { value: 2, label: 'Junior' },
    { value: 3, label: 'Mid' },
    { value: 4, label: 'Senior' },
    { value: 5, label: 'Expert' }
  ];
  private skillsByBranches = null;
  private stellarLablesEl = null;
  private allSkills: any = [];
  private skillsPerPage = 0;

  constructor(private renderer: Renderer2, private host: ElementRef) {
  }

  ngOnInit(): void {
  }

  getStars(count: number): number[] {
    return Array(count).fill(0);
  }

  prepareSkills(skills) {
    
    this.allSkills = this.addFormatColors(skills);
    this.tradeOffs = this.calcTradeOffs(skills);
    this.totalPages = this.allSkills.length ? Math.ceil(this.allSkills.length / 14) : 1;
    const chunk = Math.floor(this.allSkills.length / this.totalPages) + 1;
    this.skillsPerPage = chunk > 14 ? 14 : chunk;
  
    this.viewSkills = this.totalPages > 1 ? this.chunkArray(this.allSkills, this.skillsPerPage)[this.activePages - 1] : this.allSkills;
    this.createForm();
  }

  valueChanged(e, id) {
    this.allSkills = this.allSkills.map(item => item.id === id ? { ...item, experience: Number(e.target.value) } : item);
    const toReturn = this.skillsByBranches.map(item => ({
      ...item, skills: this.allSkills.filter(val => val.catId === item.id).map(({ color, catId, ...rest }) => rest)
    }))
    this.tradeOffs = this.calcTradeOffs(toReturn);
    this.skillsChanged.emit(toReturn);
  }

  getSkillValueByIndex(i) {
    return this.skillsForm.at(i).get('experience') as FormControl;
  }

  switchPage(to: number) {
    this.activePages = this.activePages + to;
    this.switchSlider();
  }

  toggleFocus(catId) {
    if (catId) {
      const catName = this.categoryList.find(val => val.id === catId).name;
      this.showTradeOffTooltip = `${this.tradeOffs[catId].max}/${this.tradeOffs[catId].total} skills can be at senior level in ${catName}`;
    } else {
      this.showTradeOffTooltip = null;
    }
  }

  ngAfterViewInit() {
    this.onWindowResize();
  }

  private onWindowResize() {
    const divToMeasureWidth = this.stellar.nativeElement.parentElement.parentElement.offsetWidth;
    setTimeout(() => {
      if (divToMeasureWidth < 490) {
        this.scale = 1;
        this.isMobile = true;
      } else {
        const scale = (Math.round((divToMeasureWidth / 740) * 100) + 5) / 100;
        this.verticalIntend = scale < 0.8 ? `0px auto` : `${Math.round(60 * scale)}px auto ${Math.round(60 * scale) + 5}px`;
        this.isMobile = false;
        this.scale = scale > 1 ? 1 : scale;
      }
    });
  }

  private createForm() {
    this.skillsForm.clear()
    this.viewSkills.map((item: any) => {
      const group = new FormGroup({
        id: new FormControl(item.id),
        name: new FormControl(item.name),
        experience: new FormControl(item.experience),
        color: new FormControl(item.color),
        catId: new FormControl(item.catId)
      });
      this.skillsForm.push(group);
    });
    setTimeout(() => {
      this.loading = false;
      this.ellipse(this.viewSkills.length, 290, 260, 0, 35, 'id-' + this.name, 'stellar-label');
    }, 100);
  }
  
  private ellipse(n, rx, ry, so, wh, idd, cls) {
    const el = document.getElementById('id-' + this.name);
    if (el) { el.remove(); }
    /*
      n = number of divs,
      rx = radius along X-axis,
      ry = radius along Y-axis,
      so = startOffset,
      wh = width/height of divs,
      idd = id of main div(ellipse),
      cls = className of divs;
    */
    this.stellarLablesEl = this.renderer.createElement('div');
    this.renderer.setProperty(this.stellarLablesEl, 'id', idd);
    this.renderer.addClass(this.stellarLablesEl, 'stellar-label-area');
    this.renderer.setStyle(this.stellarLablesEl, 'width', String((rx * 2) + wh) + 'px' );
    this.renderer.setStyle(this.stellarLablesEl, 'height', String((ry * 2) + wh) + 'px' );

    for (let i = 0; i < n; i++) {
      const label = this.renderer.createElement('div');
      this.renderer.addClass(label, cls);
      setTimeout(() => this.renderer.addClass(label, 'loaded'), i * 50);
      
      this.hasHints 
        ? this.renderer.setProperty(label, 'innerHTML', this.viewSkills[i].name + ' <i class="app-ico-mask app-ico-mask__info"></i>')
        : this.renderer.setProperty(label, 'innerHTML', this.viewSkills[i].name);

      const angle = (360 / n / 180) * (i + so) * Math.PI;
      this.renderer.setStyle(label, 'top', String(ry - ry * Math.cos(angle)) + 'px');
      const isRight = Math.sin(angle) > 0;
      const offset = isRight ? rx * 0.27 : rx * 0.35;
      this.renderer.setStyle(label, 'left', String(rx + rx * Math.sin(angle) - offset) + 'px');

      this.renderer.appendChild(this.stellarLablesEl, label);
    }
    this.renderer.appendChild(this.stellar.nativeElement, this.stellarLablesEl);
  }

  private switchSlider() {
    this.loading = true;
    if (!this.isMobile) {
      this.stellarLablesEl.remove();
    }
    setTimeout(() => {
      this.viewSkills = this.chunkArray(this.allSkills, this.skillsPerPage)[this.activePages - 1];
      this.createForm();
    }, 200)
  }

  private chunkArray(arr: any, size: number = 15) {
    const myArray = [];
    for (let i = 0; i < arr.length; i += size) {
      myArray.push(arr.slice(i, i + size));
    }
    return myArray;
  }

  private addFormatColors(arr) {
    if (!Array.isArray(arr)) { return []; }
    this.skillsByBranches = arr;
    const defaultColorList = [
      '#FFBBBB', '#A3E0FF', '#FFD576', '#CEFF9B', '#FF8888', '#8FF0FF', '#FFA8E1', '#C6F8E3', '#D9AEFF', '#FFB571', '#C0C7FF'
    ];
    this.categoryList = [];
    let colorList = Object.assign({}, defaultColorList);
    const skills = [];
    arr.map(item => {
      if (!colorList.length) { colorList = [...defaultColorList]; }
      // const color = colorList.shift();
      // this.categoryList.push({ name: item.name, color, id: item.id });
      // item.skills.map(skill => skills.push({ ...skill, color, catId: item.id  }));
      item.skills.map(skill => skills.push({ ...skill, color: '#A3E0FF', catId: item.id }));
    })
    return skills;
  }

  private calcTradeOffs(arr) {
    const catsTradeoff = {};
    arr.map((item: any) => {
      catsTradeoff[item.id] = { 
        total: item.skills.length,
        selected: item.skills.filter(val => val.experience === 5).length,
        max: this.countTradeOffMax(item.skills.length),
        enabled: item.skills.filter(val => val.experience === 5).length >= this.countTradeOffMax(item.skills.length)
      }
    })
    return catsTradeoff;
  }

  private countTradeOffMax(length) {
    return length <= 3 ? length : Math.round(length > 6 ? (length * 0.7) : (length * 0.8));
  }

}
